import { Route, RouteObject } from 'react-router-dom';
import Subscriptions from './components/Subscriptions';


export interface SubscriptionRoutes extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: SubscriptionRoutes[];
}

export const subscriptionRoutes: SubscriptionRoutes[] = [
  {
    path: "/onboarding/subscription",
    element: <Subscriptions />,
  },
]
